// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

/**
 * Loading skeleton for triage table.
 * Displays placeholder rows while data is being fetched.
 */
export function TriageTableSkeleton() {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell width={48}>Source</TableCell>
            <TableCell>SKU</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>First synced</TableCell>
            <TableCell>Status</TableCell>
            <TableCell width={120} align="right">
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(5)].map((_, index) => (
            <TableRow key={index}>
              <TableCell>
                <Skeleton variant="circular" width={24} height={24} />
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="80%" />
              </TableCell>
              <TableCell>
                <Stack spacing={0.5}>
                  <Skeleton variant="text" width="70%" />
                </Stack>
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="60%" />
              </TableCell>
              <TableCell>
                <Skeleton variant="rounded" width={80} height={24} />
              </TableCell>
              <TableCell align="right">
                <Skeleton variant="rounded" width={80} height={32} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
